import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import HealthCenterSuccessStoriesBody from "components/ClinicalManagement/HealthCenters/Details/HealthCenterSuccessStories/SuccessStoriesBody/HealthCenterSuccessStoriesBody";

const HealthCenterSuccessStories = () => {
  useEffect(() => {
    document.title = "Success Stories";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <HealthCenterSuccessStoriesBody />
    </main>
  );
};

export default HealthCenterSuccessStories;
